exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#my-account-dropzone[data-v-5aca2563]{min-height:120px}#my-account-add-files[data-v-5aca2563]{padding-top:40px}.dz-uploaded-file[data-v-5aca2563]{cursor:default}.dz-uploaded-file .dz-thumbnail[data-v-5aca2563]{width:0;margin-right:0}", ""]);

// exports
